// @ts-nocheck
import React from 'react';
import styled from 'styled-components';
import SmallCourseCard from './SmallCourseCard';

const Ul = styled.ul`
  & li:not(:last-child) {
    border-bottom: 1px solid #c4c4c4;
  }
`;

const MobileList = ({
  items,
  origin = 'unkown',
  trackRecommendationPosition,
}: {
  items: any[];
  origin?: string;
  trackRecommendationPosition: (
    positionSelected: number,
    originalId: number,
  ) => void;
}) => {
  return (
    <Ul style={{ marginTop: -24, marginBottom: -24 }}>
      {items.map((el, idx) => (
        <li key={`mobile-list${el.originalId}`}>
          <SmallCourseCard
            item={el}
            origin={origin}
            idx={idx + 1}
            trackRecommendationPosition={trackRecommendationPosition}
          />
        </li>
      ))}
    </Ul>
  );
};

export default MobileList;
